<div class="how-to-schedule-pickup-dialog ups-dialog">
    <div class="how-to-schedule-pickup-dialog-header">
        <span mat-dialog-title class="how-to-schedule-pickup-dialog-title">Schedule New Pickup Instructions</span>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="how-to-schedule-pickup-dialog-content">
        <div class="how-to-schedule-pickup-instruction-wrapper">
            <span class="how-to-schedule-pickup-instruction-header">1. Go to 'Shipment History' page</span>
            <span>Click on 'Track' on the left panel, and then go to 'Shipment History' page.</span>
        </div>

        <div class="how-to-schedule-pickup-instruction-wrapper">
            <span class="how-to-schedule-pickup-instruction-header">2. Select shipment and view detail</span>
            <span>Choose a shipment and click on the button 'View' to view the shipment details.</span>
        </div>

        <div class="how-to-schedule-pickup-instruction-wrapper">
            <span class="how-to-schedule-pickup-instruction-header">3. Schedule a pickup</span>
            <span>In the 'Shipment Details' popup, click the 'Schedule Pickup' button.</span>
        </div>
    </div>
</div>